import Immutable from 'seamless-immutable'
import _ from 'lodash'

import { getAllQueryKeys } from 'utils/parameters'

import * as actions from './actions'

const initialState = Immutable.from({
  viewMode: 'list',
  isFetching: false,
  error: false,
  parameters: {},
  activeParameters: [],
  decidingKeys: [],
  validQueryKeys: [],
  byQueryKey: {},
  filterQuery: {},
})

const searchParams = (state = initialState, { type, payload, error }) => {
  switch (type) {
    case actions.REQUEST_PARAMETERS:
      return state.merge({
        isFetching: true,
        error: false,
      })
    case actions.RECEIVE_PARAMETERS: {
      if (error) {
        return state.merge({
          isFetching: false,
          error: true,
        })
      }

      return state.merge({
        isFetching: false,
        parameters: payload,
        byQueryKey: _.keyBy(payload, 'queryKey'),
        validQueryKeys: _.uniq(getAllQueryKeys(payload)),
      })
    }

    case actions.SET_DECIDING_KEYS:
      return state.set('decidingKeys', payload)

    case actions.SAVE_FILTER_PARAMETERS:
      return state.merge({ filterQuery: payload })

    case actions.REQUEST_ACTIVE_PARAMETERS:
      return state.merge({
        isFetching: true,
        error: false,
      })
    case actions.RECEIVE_ACTIVE_PARAMETERS: {
      if (error) {
        return state.merge({
          isFetching: false,
          error: true,
        })
      }

      return state.merge({
        isFetching: false,
        byQueryKey: _.keyBy(payload, 'queryKey'),
        activeParameters: payload,
      })
    }
    case actions.UPDATE:
      return state.merge(payload, { deep: true })
    default:
      return state
  }
}

export default searchParams
